const mixProperties = {
  computed: {
    button_type() {
      let result = null
      let paypal_position = this.paypal_product_position
      //有可用的paypal支付方式
      let paypal_enabled = this.paypal_enabled && this.paypal_enabled !== 'none'
      //是否登陆过paypal
      let pyapal_remembered = true || window.paypalIsRemembered && window.paypalIsRemembered.paypal
      //有机会显示paypal的选项
      let enable_smart_btn = ['yes', 'yes_horizontal', 'yes_vertical'].includes(paypal_position)

      //设置为buynow || 设置paypal 但没有可用方式 || 设置智能显示后没有登陆过paypal;
      if (paypal_position == 'buynow' || (enable_smart_btn && (!paypal_enabled || !pyapal_remembered))) {
        result = 'buynow'
      } else if (enable_smart_btn && paypal_enabled) {
        result = 'paypal'
      }
      return result
    },
  },
  methods: {
    mixProperties() {
      let customFormProperties = { resume: true, files: {}, properties: {} }
      let customInput = this.$('.custom-form-properties input')
      let customForm = this.$('.custom-form-properties form')
      if (!customForm.length) {
        customForm = this.$('.addcart form')
      }
      if (customInput.length && customForm.length) {
        let formData = new FormData(customForm[0])
        customFormProperties.resume = customForm[0].reportValidity()
        for (let [key, val] of formData.entries()) {
          if (Object.prototype.toString.call(val) !== '[object File]') {
            if (customFormProperties.properties[key]) {
              customFormProperties.properties[key] = customFormProperties.properties[key] + ' , ' + val
            } else {
              customFormProperties.properties[key] = val
            }
          }
        }
        customInput.each((index, item) => {
          let { name, files } = item
          if (files && files.length) {
            customFormProperties.files[name] = files
          }
        })
        return customFormProperties
      } else {
        return false
      }
    },
  },
}
export default mixProperties
